import { createContext, useContext, useState, useEffect } from "react";

const BrandContext = createContext();

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(() => {
    // Initialize from localStorage if available
    return sessionStorage.getItem("selectedBrand") || null;
  });

  // Keep localStorage in sync with brand
  useEffect(() => {
    if (brand) {
      sessionStorage.setItem("selectedBrand", brand);
    } else {
      sessionStorage.removeItem("selectedBrand");
    }
  }, [brand]);

  return (
    <BrandContext.Provider value={{ brand, setBrand }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => useContext(BrandContext);
